import { render } from "./DetalharReceitaPlano.vue?vue&type=template&id=d9448ae4&scoped=true"
import script from "./DetalharReceitaPlano.vue?vue&type=script&lang=js"
export * from "./DetalharReceitaPlano.vue?vue&type=script&lang=js"

import "./DetalharReceitaPlano.vue?vue&type=style&index=0&id=d9448ae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9448ae4"]])

export default __exports__